import { createStore } from 'vuex'
import Service from '@/request/service.js'
import { menuTypes } from '@/constants/index.js'
import { useUseragent } from '@/helpers/useragent.js'

const setEmptyCart = () => {
    return {
        [menuTypes.menu]: [],
        [menuTypes.takeaway]: [],
        [menuTypes.marketplace]: [],
    }
}

const getCart = () => {
    if (localStorage.getItem('cart') === '[]') {
        localStorage.removeItem('cart')
    }
    return localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : setEmptyCart()
}

const state = {
    $currentRoute: null,
    gif: null,
    comment: '',
    image: null,
    audio: null,
    rating: null,
    stickers: [],
    details: null,
    loading: false,
    marketplaceParams: [],
    showMapModal: false,
    cards: localStorage.getItem('cards') ?? [],
    token: localStorage.getItem('token') ?? null,
    // token: document.cookie.split('; ').find(row =>
    //   row.startsWith(import.meta.env.MODE === 'production' ? 'appToken=' : 'devAppToken=')
    // )?.split('=')[1],
    locale: localStorage.getItem('locale') || 'ru',
    refresh: localStorage.getItem('refresh') ?? null,
    // refresh: document.cookie.split('; ').find(row =>
    //   row.startsWith(import.meta.env.MODE === 'production' ? 'appRefreshToken=' : 'devAppRefreshToken=')
    // )?.split('=')[1],
    askTips: localStorage.getItem('askTips') ?? 'hide',
    lastCard: localStorage.getItem('lastCard') ?? null,
    homeRoute: localStorage.getItem('homeRoute') ?? '/',
    askLocale: localStorage.getItem('askLocale') ?? 'show',
    paymentMode: localStorage.getItem('paymentMode') ?? 'billntips',
    lastPaymentMethod: localStorage.getItem('lastPaymentMethod') ?? null,
    lastPaymentMember: localStorage.getItem('lastPaymentMember') ?? null,
    lastPaymentMemberUrl: localStorage.getItem('lastPaymentMemberUrl') ?? null,
    lastPaymentMemberLogo: localStorage.getItem('lastPaymentMemberLogo') ?? null,
    paymentSystemsList: localStorage.getItem('paymentSystems') ?? '[]',

    addressChangedTime: localStorage.getItem('addressChangedTime') ? +localStorage.getItem('addressChangedTime') : 0,
    // Menu
    visitTime: localStorage.getItem('visitTime') ? +localStorage.getItem('visitTime') : Date.now(),
    cart: getCart(),
    order: localStorage.getItem('order') ? JSON.parse(localStorage.getItem('order')) : [],
}

const mutations = {
    SET_VISIT_TIME(state) {
        state.visitTime = Date.now();
        localStorage.setItem('visitTime', `${state.visitTime}`);
    },

    SET_CURRENT_ROUTE(state, newRoute) {
        state.$currentRoute = newRoute;
    },

    SET_TOKEN(state, token) {
        localStorage.setItem('token', token)
        // const key = import.meta.env.MODE === 'production' ? 'appToken' : 'devAppToken'
        // setCookie(key, token)
        state.token = token
    },

    SET_REFRESH(state, refresh) {
        localStorage.setItem('refresh', refresh)
        // const key = import.meta.env.MODE === 'production' ? 'appRefreshToken' : 'devAppRefreshToken'
        // setCookie(key, refresh)
        state.refresh = refresh
    },

    SET_LOCALE(state, locale) {
        localStorage.setItem('locale', locale)
        state.locale = locale
    },

    SET_LOADING(state, value) {
        state.loading = value
    },

    SET_ASK_TIPS(state, value) {
        localStorage.setItem('askTips', value)
        state.askTips = value
    },

    SET_ASK_LOCALE(state, value) {
        localStorage.setItem('askLocale', value)
        state.askLocale = value
    },

    SET_PAYMENT_MODE(state, value) {
        localStorage.setItem('paymentMode', value)
        state.paymentMode = value
    },

    SET_LAST_PAYMENT_METHOD(state, value) {
        if (value) localStorage.setItem('lastPaymentMethod', value)
        state.lastPaymentMethod = value
    },

    SET_LAST_PAYMENT_MEMBER(state, value) {
        if (value) localStorage.setItem('lastPaymentMember', value)
        state.lastPaymentMember = value
    },

    SET_LAST_PAYMENT_MEMBER_URL(state, value) {
        if (value) localStorage.setItem('lastPaymentMemberUrl', value)
        state.lastPaymentMemberUrl = value
    },

    SET_LAST_PAYMENT_MEMBER_LOGO(state, value) {
        if (value) localStorage.setItem('lastPaymentMemberLogo', value)
        state.lastPaymentMemberLogo = value
    },

    SAVE_CARD(state, card) {
        if (state.cards && state.cards.length > 0) {
            const cards = JSON.parse(state.cards)
            if (cards.filter((e) => e?.pan === card?.pan).length > 0) {
                console.log("card not found")
            } else {
                cards.push(card)
            }
            state.cards = JSON.stringify(cards)
        } else {
            let _cards = []
            _cards.push(card)
            state.cards = JSON.stringify(_cards)
        }
        localStorage.setItem('cards', state.cards)
    },

    SET_SORTED_CARDS(state, cards) {
        if (Array.isArray(cards)) {
            state.cards = JSON.stringify(cards);
        }
        else {
            console.log('Sorting cards is not array');
        }
    },

    SET_LAST_CARD(state, token) {
        state.lastCard = token
        localStorage.setItem('lastCard', token)
    },

    SET_HOME_ROUTE(state, value) {
        state.homeRoute = value
        localStorage.setItem('homeRoute', value)
    },

    SET_RATING(state, value) {
        state.rating = value
    },

    SET_COMMENT(state, value) {
        state.comment = value
    },

    SET_STICKERS(state, value) {
        state.stickers = value
    },

    SET_DETAILS(state, value) {
        state.details = value
    },

    SET_IMAGE(state, value) {
        state.image = value
    },

    SET_GIF(state, value) {
        state.gif = value
    },

    SET_AUDIO(state, value) {
        state.audio = value
    },

    REMOVE_CARD(state, token) {
        let cards = JSON.parse(state.cards)
        const card = cards.find(c => c.token === token)
        const index = cards.indexOf(card)
        cards.splice(index, 1)
        state.cards = JSON.stringify(cards)
        localStorage.setItem('cards', state.cards)
    },

    FLUSH_CARDS(state) {
        state.cards = []
        localStorage.setItem('cards', '[]')
    },

    LOGOUT(state) {
        state.token = null
        state.refresh = null
        state.paymentSystemsList = '[]'
        localStorage.removeItem('token')
        // const token = import.meta.env.MODE === 'production' ? 'appToken' : 'devAppToken'
        // setCookie(token, '')
        localStorage.removeItem('refresh')
        // const refresh = import.meta.env.MODE === 'production' ? 'appRefreshToken' : 'devAppRefreshToken'
        // setCookie(refresh, '')
    },

    SET_PAYMENT_SYSTEMS_LIST(state, list) {
        state.paymentSystemsList = list
        localStorage.setItem('paymentSystems', JSON.stringify(list))
    },

    SET_PARAMS(state, params) {
        state.marketplaceParams = params
    },

    UPDATE_KITCHEN_PARAM(state, kitchens) {
        state.marketplaceParams.kitchens = kitchens
    },

    UPDATE_SEARCH_PARAM(state, search) {
        state.marketplaceParams.name = search
    },

    UPDATE_BRAND_PARAM(state, brand) {
        state.marketplaceParams.brand_id = brand
    },

    CLEAR_PARAMS(state) {
        state.marketplaceParams = []
    },

    SET_ADDRESS_CHANGED_TIME(state) {
        state.addressChangedTime = Date.now();
        localStorage.setItem('addressChangedTime', state.addressChangedTime);
    },

    // Menu
    ADD_TO_CART(state, payload) {
        state.cart[payload.menuType] = [...state.cart[payload.menuType], payload]
    },

    UPDATE_CART_PRODUCT_COUNT(state, payload) {
        state.cart[payload.menuType] = state.cart[payload.menuType].map((product) => {
            if (product.idx !== payload.idx) return product;
            return { ...product, count: payload.count };
        });
    },

    REMOVE_FROM_CART(state, { idx, menuType }) {
        state.cart[menuType] = state.cart[menuType].filter(product => product.idx !== idx);
    },

    FLUSH_CART(state, menuType) {
        if (!menuType) return;
        state.cart = { ...state.cart, [menuType]: [] }
        localStorage.setItem('cart', JSON.stringify(state.cart))
    },

    PUSH_ORDER(state, payload) {
        state.order = [...state.order, payload]
        localStorage.setItem('order', JSON.stringify(state.order))
    },

    FLUSH_ORDER(state, menuType) {
        state.order = state.order.filter(order => order.menuType !== menuType);
        localStorage.setItem('order', JSON.stringify(state.order))
    },

    OPEN_MAP_MODAL(state) {
        state.showMapModal = true;
    },

    CLOSE_MAP_MODAL(state) {
        state.showMapModal = false;
    }
}

const actions = {
    logout: ({ commit }) => commit('LOGOUT'),
    flushCards: ({ commit }) => commit('FLUSH_CARDS'),
    clearParams: ({ commit }) => commit('CLEAR_PARAMS'),
    setGif: ({ commit }, value) => commit('SET_GIF', value),
    saveCard: ({ commit }, value) => commit('SAVE_CARD', value),
    setImage: ({ commit }, value) => commit('SET_IMAGE', value),
    setToken: ({ commit }, value) => commit('SET_TOKEN', value),
    setAudio: ({ commit }, value) => commit('SET_AUDIO', value),
    setLocale: ({ commit }, value) => commit('SET_LOCALE', value),
    setRating: ({ commit }, value) => commit('SET_RATING', value),
    setParams: ({ commit }, value) => commit('SET_PARAMS', value),
    removeCard: ({ commit }, value) => commit('REMOVE_CARD', value),
    setDetails: ({ commit }, value) => commit('SET_DETAILS', value),
    setComment: ({ commit }, value) => commit('SET_COMMENT', value),
    setRefresh: ({ commit }, value) => commit('SET_REFRESH', value),
    setLoading: ({ commit }, value) => commit('SET_LOADING', value),
    setAskTips: ({ commit }, value) => commit('SET_ASK_TIPS', value),
    setStickers: ({ commit }, value) => commit('SET_STICKERS', value),
    setAskLocale: ({ commit }, value) => commit('SET_ASK_LOCALE', value),
    setHomeRoute: ({ commit }, value) => commit('SET_HOME_ROUTE', value),
    setPaymentMode: ({ commit }, value) => commit('SET_PAYMENT_MODE', value),
    setLastChosenCard: ({ commit }, value) => commit('SET_LAST_CARD', value),
    updateBrandParam: ({ commit }, value) => commit('UPDATE_BRAND_PARAM', value),
    updateSearchParam: ({ commit }, value) => commit('UPDATE_SEARCH_PARAM', value),
    updateKitchenParams: ({ commit }, value) => commit('UPDATE_KITCHEN_PARAM', value),
    setLastPaymentMethod: ({ commit }, value) => commit('SET_LAST_PAYMENT_METHOD', value),
    setLastPaymentMember: ({ commit }, value) => commit('SET_LAST_PAYMENT_MEMBER', value),
    setPaymentSystemsList: ({ commit }, value) => commit('SET_PAYMENT_SYSTEMS_LIST', value),
    setLastPaymentMemberUrl: ({ commit }, value) => commit('SET_LAST_PAYMENT_MEMBER_URL', value),
    setLastPaymentMemberLogo: ({ commit }, value) => commit('SET_LAST_PAYMENT_MEMBER_LOGO', value),

    checkVisitTime({ commit }) {
        if (!localStorage.getItem('visitTime')) {
            commit('SET_VISIT_TIME');
        }
        else {
            const maxDifference = 1000 * 60 * 40; // 40 minutes;
            const diff = Date.now() - this.state.visitTime;

            if (diff >= maxDifference) {
                commit('FLUSH_CART', menuTypes.menu);
                commit('FLUSH_CART', menuTypes.takeaway);
                commit('FLUSH_CART', menuTypes.marketplace);
                commit('SET_VISIT_TIME');
            }
        }
    },
    // Menu
    addToCart({ commit }, product) {
        const { menuType } = product;
        const productsInCart = this.state.cart[menuType].filter((item) => item.id === product.id);
        if (!productsInCart.length) {
            commit("ADD_TO_CART", product);
        }
        else {
            const similarProduct = productsInCart.find((cartProduct) => {
                return JSON.stringify(cartProduct.modifiers) === JSON.stringify(product.modifiers);
            });

            if (!similarProduct) {
                commit("ADD_TO_CART", product);
            }
            else {
                commit("UPDATE_CART_PRODUCT_COUNT", { ...similarProduct, count: similarProduct.count + product.count });
            }
        }
        localStorage.setItem('cart', JSON.stringify(this.state.cart));
    },

    updateCartItemCount({ commit }, item) {
        commit('UPDATE_CART_PRODUCT_COUNT', item)
        localStorage.setItem('cart', JSON.stringify(this.state.cart));
    },

    flushCart({ commit }, menuType) {
        commit("FLUSH_CART", menuType);
    },
    removeFromCart({ commit }, product) {
        commit("REMOVE_FROM_CART", { idx: product.idx, menuType: product.menuType });
        localStorage.setItem('cart', JSON.stringify(this.state.cart));
    },

    async makeOrder({ commit }, payload) {
        const headers = {
            'X-Menu-Access-Token': `Bearer ${payload.token}`,
            'X-Menu-Client': useUseragent().getUserAgent()
        }
        const res = await Service.makeOrder(payload.order, headers);
        commit("FLUSH_CART", payload.menuType)
        const order = {
            type: payload.order.type,
            guid: res.data.data.guid,
            data: res.data.data
        }
        if (payload.order.table) {
            order.table = payload.order.table
        } else if (payload.order.store) {
            order.store = payload.order.store
        }
        //commit("PUSH_ORDER", order)
        return res.data.data
    },

    async editOrder({ commit }, payload) {
        const headers = { 'X-Menu-Access-Token': `Bearer ${payload.token}` }
        const res = await Service.editOrder(payload.order, headers);
        commit("FLUSH_CART", payload.menuType)
        const order = {
            type: payload.order.type,
            guid: res.data.data.guid,
            data: res.data.data
        }
        if (payload.order.table) {
            order.table = payload.order.table
        } else if (payload.order.store) {
            order.store = payload.order.store
        }
        //commit("PUSH_ORDER", order)
        return res.data.data
    },

    setOrder({ commit }, order) {
        commit("FLUSH_ORDER", order.menuType)
        commit("PUSH_ORDER", order)
    },

    flushOrder({ commit }, type) {
        commit("FLUSH_ORDER", type)
    },

    openMapModal({ commit }) {
        commit('OPEN_MAP_MODAL');
    },

    closeMapModal({ commit }) {
        commit('CLOSE_MAP_MODAL');
    }
}

const getters = {
    gif: state => state.gif,
    image: state => state.image,
    token: state => state.token,
    audio: state => state.audio,
    locale: state => state.locale,
    rating: state => state.rating,
    details: state => state.details,
    comment: state => state.comment,
    refresh: state => state.refresh,
    loading: state => state.loading,
    askTips: state => state.askTips,
    stickers: state => state.stickers,
    lastCard: state => state.lastCard,
    askLocale: state => state.askLocale,
    homeRoute: state => state.homeRoute,
    cards: state => getCards(state.cards),
    paymentMode: state => state.paymentMode,
    marketplaceParams: state => state.marketplaceParams,
    lastPaymentMethod: state => state.lastPaymentMethod,
    lastPaymentMember: state => state.lastPaymentMember,
    lastPaymentMemberUrl: state => state.lastPaymentMemberUrl,
    lastPaymentMemberLogo: state => state.lastPaymentMemberLogo,
    paymentSystemsList: state => getPaymentSystems(state.paymentSystemsList),
    // Menu
    //cart: state => getCart(state.cart),
    cart: (state, getters) => {
        return state.cart[getters.menuType]
    },

    cartAddedProductsCount: (state, getters) => {
        return getters.cart.reduce((acc, product) => {
            acc[product.id] = product.count;
            return acc;
        }, {});
    },

    cartTotalPrice: (state, getters) => {
        return getters.cart.reduce((acc, curr) => {
            return acc += (!curr.modifiers ? 0 : curr.modifiers.reduce((accMod, currMod) => accMod += currMod.quantity * currMod.price, 0) + curr.price) * curr.count;
        }, 0)
    },

    isAddressChangedRecently: state => {
        if (!state.addressChangedTime) return false;
        return Date.now() - state.addressChangedTime < 4 * 1000 * 3600;
    },

    order: state => getOrder(state.order),
    menuType(state) {
        if (!state.$currentRoute) return '';
        if (state.$currentRoute.path.includes('/marketplace/') || state.$currentRoute.name.includes('marketplace')) return menuTypes.marketplace;
        if (state.$currentRoute.path.includes('/t/')) return menuTypes.takeaway;
        if (state.$currentRoute.path.includes('/m/')) return menuTypes.menu;
        return '';
    }
}

const getPaymentSystems = list => {
    if (typeof list === 'string' && list.length > 0) {
        list = JSON.parse(state.paymentSystemsList)
    }
    return list
}

const getOrder = order => {
    if (typeof order === 'string' && order.length > 0) {
        order = JSON.parse(order)
    }
    return order
}

const getCards = cards => {
    if (typeof cards === 'string' && cards.length > 0) {
        cards = JSON.parse(cards)
    }
    // cards = sortCards(cards)
    return cards
}

// const sortCards = cards => cards.sort((a, b) => {
//     if (a?.token === state.lastCard)
//         return -1
//     if (b?.token === state.lastCard)
//         return 1
//     return 0
// })

// const setCookie = (key, token) => {
//   const isProd = import.meta.env.MODE === 'production'
//   const secure = isProd ? 'Secure; ' : ''
//   const sameSite = isProd ? 'SameSite=None; ' : ''
//   const domain = ['production', 'development'].includes(import.meta.env.MODE) ? 'Domain=.rhmt.uz; ' : ''
//   document.cookie = `${key}=${token}; Path=/; ${domain}${secure}${sameSite}Max-Age=${30 * 24 * 3600}`
// }

export default createStore({
    state,
    getters,
    actions,
    mutations
})
